module.exports = __webpack_public_path__ + "static/media/404.16d41f0c.jpg";